// WebRTC yerlesik ses on-isleme kisitlari. Saf, yan-etkisiz.
//
// ECHO CANCELLATION HER ZAMAN ACIK (2026-09-14): eskiden ucu de tek "gurultu
// engelleme" anahtarina baglanmisti; kullanici o anahtari kapatinca AEC de
// kapaniyor ve kulakliksiz konusanlarda hoparlorden cikan ses mikrofona geri
// girip siddetli yanki yapiyordu. Anahtar artik yalnizca gurultu bastirma ve
// otomatik kazanci yonetir; yanki bastirma kullanicidan bagimsiz acik kalir.
export function buildAudioCaptureOptions(enabled, deviceId, withVoiceIsolation = false) {
  const opts = {
    echoCancellation: true,
    noiseSuppression: enabled,
    autoGainControl: enabled,
  }
  // Chromium 122+ "voiceIsolation": guclu ses ayiklama kipi; desteklenmiyorsa eklenmez.
  if (withVoiceIsolation) opts.voiceIsolation = enabled
  if (deviceId) opts.deviceId = deviceId
  return opts
}

/** Tarayici voiceIsolation kisitini taniyor mu? (yan etkisiz sorgu) */
export function supportsVoiceIsolation() {
  try {
    const c = navigator.mediaDevices?.getSupportedConstraints?.()
    return !!c && c.voiceIsolation === true
  } catch {
    return false
  }
}

export const NOISE_SUPPRESSION_KEY = 'memeet.noiseSuppression'
export function loadNoiseSuppression() {
  try { return localStorage.getItem(NOISE_SUPPRESSION_KEY) !== 'false' } catch { return true }
}
export function saveNoiseSuppression(enabled) {
  try { localStorage.setItem(NOISE_SUPPRESSION_KEY, enabled ? 'true' : 'false') } catch { /* yut */ }
}
